import { Alert, AlertIcon, Button, Icon, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiExternalLink } from "react-icons/fi";
import { Link as RouterLink } from "react-router-dom";
import { useGetNeedQuery } from "../../autogen/bff-api";
import { urls } from "../../urls";

export const MarketDialogueNeedNotice = ({ needId, createdFromNeed }: { needId: string; createdFromNeed: boolean }) => {
  const { t } = useTranslation();
  const { data: need } = useGetNeedQuery({ needId });
  if (!need) return null;
  const title = need.title?.trim() || t("Untitled");
  return (
    <Alert status="info" borderRadius="md" mt="4" alignItems="flex-start" data-testid="market-dialogue-need-notice">
      <AlertIcon />
      <Stack spacing="2" flex="1" minW="0" fontSize="sm">
        <Text>
          {createdFromNeed
            ? t("Created from the need «{{title}}».", { title })
            : t("Linked to the need «{{title}}».", { title })}
        </Text>
        <Button
          as={RouterLink}
          to={urls.app.needs.view.go(need.id)}
          target="_blank"
          variant="link"
          size="sm"
          alignSelf="flex-start"
          colorScheme="teal"
          rightIcon={<Icon as={FiExternalLink} />}
        >
          {t("Open the need")}
        </Button>
      </Stack>
    </Alert>
  );
};
